import React from 'react';

import { OrdCreate, OrdEdit, OrdShow } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { GroupsForm } from './GroupsForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { GroupRead } from '@ragu-components/ord-types';

const GroupsList = React.lazy(async () => import('./GroupsList'));

export const groupsResource: OrdResourceProps = {
  key: Resources.groups,
  name: Resources.groups,
  list: <GroupsList />,
  create: (
    <OrdCreate>
      <GroupsForm />
    </OrdCreate>
  ),
  edit: (
    <OrdEdit>
      <GroupsForm />
    </OrdEdit>
  ),
  show: (
    <OrdShow>
      <GroupsForm />
    </OrdShow>
  ),
  options: {},
  recordRepresentation: (record: GroupRead): string => record.name,
};
